import { BaseQueryApi, createApi, QueryReturnValue } from "@reduxjs/toolkit/query/react";
// import { axiosBaseQuery } from "../../../../api/agent";
import {
  IJobAdvanceFilter,
  IJobFilter,
  IJobTemplate,
  IMasterDataFilter,
  IMasterDataResponse,
} from "../../../../models/Job/Jobs";
import { IAppResponse } from "../../../../models/App/AppModel";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface JobState {
  preferences: {
    industries: string[];
    jobTitle: string[];
    lastIndustries: string[];
    client?: string;
  };
}
interface GetJobsResponse {
  data?: {
    messageList: any[]; // Replace `any[]` with the specific type of the job list if known
  };
  error?: {
    message: string;
  };
}

export const JobAPI = createApi({
  reducerPath: "JobSlice",
  endpoints: (build) => ({
    getMasterData: build.mutation<
      IAppResponse<IMasterDataResponse>,
      IMasterDataFilter
    >({
      query: (data: any) => ({
        url: `/eximius/api/v2/get_masterdata`,
        method: "post",
        data: data,
      }),
    }),
  }),
  baseQuery: function (args: any, api: BaseQueryApi, extraOptions: {}): QueryReturnValue<unknown, unknown, {}> | PromiseLike<QueryReturnValue<unknown, unknown, {}>> {
    throw new Error("Function not implemented.");
  }
});

export const {
  useGetMasterDataMutation,
} = JobAPI;
export const ServiceAPIReducer = JobAPI.reducer;

const initialState: JobState = {
  preferences: {
    industries: [],
    jobTitle: [],
    lastIndustries: [],
  },
};

export const JobSlice = createSlice({
  name: "job",
  initialState: initialState,
  reducers: {
    addIndustryPreference: (state, action: PayloadAction<string[]>) => {
      state.preferences.industries = Array.from(
        new Set([...action.payload, ...state.preferences.industries])
      );
      state.preferences.lastIndustries = action.payload;
    },
    addJobTitlePreference: (state, action: PayloadAction<string[]>) => {
      state.preferences.jobTitle = [
        ...action.payload,
        ...state.preferences.jobTitle,
      ];
    },
    addPreferedClient: (state, action: PayloadAction<string>) => {
      state.preferences.client = action.payload;
    },
  },
});

export const {
  addIndustryPreference,
  addJobTitlePreference,
  addPreferedClient,
} = JobSlice.actions;

export const JobReducer = JobSlice.reducer;
